/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { displayMessage } from '@insticator/insticator-ui'; // iui-state
import { getDetailRevenueMetrics, updateDetailDateRange } from 'state/actions/detailViewState/detailViewStatus';
import { updataDetailDropDown, fetchRONSites, fetchCountries, clearDetailState } from 'state/actions/detailViewState/detailViewStatus';
// component
import Revenue from 'pages/dashboard/analytics/detail/metrics/revenue/revenue';



/* ========== ~~~~~~~~~~ DATA REVENUE : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ detailViewStatus, homeState, sessionStatus, accountData }) => {
    const { homeAnalyticsStatus } = homeState;
    return {
        devices: detailViewStatus.devices,
        selectedDevices: detailViewStatus.selectedDevices,
        countries: detailViewStatus.countries,
        countriesReceived: detailViewStatus.countriesReceived,
        selectedCountries: detailViewStatus.selectedCountries,
        ronSites: detailViewStatus.ronSites,
        sitesReceived: accountData.sitesReceived,
        ronSitesReceived: detailViewStatus.ronSitesReceived,
        sites: accountData.sites,
        selectedSites: detailViewStatus.selectedSites,
        selectedRevenueType: homeAnalyticsStatus.selectedRevenueType,
        dateRange: detailViewStatus.dateRange,
        revenueDetail: detailViewStatus.revenueDetail,
        fetchingRevenue: detailViewStatus.fetchingRevenue,

        accountUUID: sessionStatus.accountUUID
    }};

// map actions
const mapDispatchToProps = dispatch => ({
    displayMessage: message => dispatch(displayMessage(message)),
    updateDateRange: range => dispatch(updateDetailDateRange(range)),
    updateDetailDropDown: (items, itemType) => dispatch(updataDetailDropDown(items, itemType)),
    fetchCountries: (accountUUID, paramString) => dispatch(fetchCountries(accountUUID, paramString)),
    fetchRONSites: (accountUUID, paramString) => dispatch(fetchRONSites(accountUUID, paramString)),
    getDetailRevenueMetrics: (paramString, dataType) => dispatch(getDetailRevenueMetrics(paramString, dataType)),
    clearDetailState: () => dispatch(clearDetailState())
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Revenue);
